import { Inject, Injectable, InjectionToken } from '@angular/core';

import { BehaviorValue, CanvasAppState, IndicationsTableState, State, ToolbarAppState, Value } from '@olympus/ngx-shared';

import { ReadingAppState } from './readings.state';
import { StatisticAppState } from './statistics.state';

export const APP_STATE_TOKEN: InjectionToken<any> = new InjectionToken<any>('APP_STATE_TOKEN');
export const APP_STATE_INITIALIZERS: InjectionToken<any> = new InjectionToken<any>('APP_STATE_INITIALIZERS');

interface IDataButtonState {
  enabled: boolean;
  icon?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export type WindViewAppState = {
  Authenticated: Value<boolean>,
  AuthToken: Value<string>,
  Initial: Value<string>,
  OpenFileDialog: BehaviorValue<IDataButtonState>,
  FileIsUploading: BehaviorValue<boolean>,
  ReportIsUploading: BehaviorValue<boolean>,
  UploadProgress: Value<number>,
  FileExtension: BehaviorValue<string>,
  DriveFileId: BehaviorValue<string>,
  DriveFileName: BehaviorValue<string>,
  AppVersion: Value<string>,
  AppName: Value<string>,
  AppNameVersion: Value<string>,
  DriveFileDownloadTime: BehaviorValue<number>,
  DpuFileOpeningTime: BehaviorValue<number>,
  DriveFileSize: BehaviorValue<number>,
};
/* eslint-enable @typescript-eslint/naming-convention */

export function windViewStateInitializer(): WindViewAppState {
  return {
    Authenticated: new Value(false),
    AuthToken: new Value(),
    Initial: new Value('U'),
    OpenFileDialog: new BehaviorValue({ enabled: false }),
    FileIsUploading: new BehaviorValue(false),
    ReportIsUploading: new BehaviorValue(false),
    UploadProgress: new Value(0),
    FileExtension: new BehaviorValue(''),
    DriveFileId: new BehaviorValue(''),
    DriveFileName: new BehaviorValue(''),
    DriveFileDownloadTime: new BehaviorValue(-1),
    DpuFileOpeningTime: new BehaviorValue(-1),
    DriveFileSize: new BehaviorValue(-1),
    AppVersion: new Value(null),
    AppName: new Value(null),
    AppNameVersion: new Value(null),
  };
}

export type WindViewStateType =
  & WindViewAppState
  & ReadingAppState
  & CanvasAppState
  & ToolbarAppState
  & IndicationsTableState
  & StatisticAppState;

@Injectable({
  providedIn: 'root',
})
export class WindViewState extends State<WindViewStateType> {
  constructor(@Inject(APP_STATE_INITIALIZERS) state$: WindViewStateType) {
    super(state$);
  }
}
